import { UserLocation } from '@combinativ/client-api';

export function loadUserLocation(): UserLocation {
    const tag = document.querySelector('script[type="user-location"]');
    if (!tag || !tag.textContent) {
        throw new Error('User location could not be found on the page');
    }
    return JSON.parse(tag.textContent);
}
